import {
    ApiSectionType,
    STOREFRONT_METRICS,
    StorefrontMetric,
} from '@storefronts/common-types'
import { StorefrontFilter, StorefrontFilterOption } from './types'
import { BsCircleFill, BsArchive, BsLightning, BsMoon } from 'react-icons/bs'

export const NO_IMAGE_URL =
    'https://res.cloudinary.com/viddyapp/image/upload/v1745856735/ChatGPT_Image_Apr_28_2025_12_11_25_PM_aegako.png'

export const SECTION_TYPE_LABELS: Record<ApiSectionType, string> = {
    [ApiSectionType.HEADER_TEXT]: 'Header Text',
    [ApiSectionType.BODY_TEXT]: 'Body Text',
    [ApiSectionType.RICH_TEXT]: 'Rich Text',
    [ApiSectionType.HTML]: 'HTML',
    [ApiSectionType.ACCORDION]: 'Accordion',
    [ApiSectionType.CTA_BUTTON]: 'Button',
    [ApiSectionType.CAROUSEL]: 'Image Carousel',
    [ApiSectionType.VIDEO_CAROUSEL]: 'Video Carousel',
    [ApiSectionType.PERSONALIZED_PLP]: 'Personalized Product Grid',
    [ApiSectionType.PLP]: 'Product Grid',
    [ApiSectionType.PRODUCT_CARD]: 'Product Card',
    [ApiSectionType.INLINE_PDP]: 'Inline Product',
    [ApiSectionType.UPSELL_BOX]: 'Upsell Box',
    [ApiSectionType.COLLECTIONS_SECTION]: 'Collections',
    [ApiSectionType.REVIEWS_SUMMARY]: 'Reviews Summary',
    [ApiSectionType.REVIEWS_SECTION]: 'Reviews Section',
    [ApiSectionType.AI_REVIEWS_SUMMARY]: 'AI Review Summary',
    [ApiSectionType.REVIEWS_CAROUSEL]: 'Reviews Carousel',
    [ApiSectionType.REVIEWS_IMAGES]: 'Reviews Images',
    [ApiSectionType.SPACER]: 'Spacer',
}

export const METRICS_CONFIG = {
    CACHE_TTL: 120 * 60 * 1000, // 2 hours
    DEFAULT_DAYS: 30,
    AVAILABLE_METRICS: Object.keys(STOREFRONT_METRICS) as StorefrontMetric[],
} as const

export const STOREFRONT_FILTERS: StorefrontFilterOption[] = [
    {
        id: StorefrontFilter.ALL_ACTIVE,
        label: 'All Storefronts',
        description: 'All storefronts that are not archived',
        icon: BsCircleFill,
    },
    {
        id: StorefrontFilter.WITH_TRAFFIC,
        label: 'Live Storefronts',
        description:
            'Storefronts with recent visits based on the selected time period',
        icon: BsLightning,
    },
    {
        id: StorefrontFilter.NO_TRAFFIC,
        label: 'No Traffic',
        description:
            'Active but no recent visits based on the selected time period',
        icon: BsMoon,
    },
    {
        id: StorefrontFilter.ARCHIVED,
        label: 'Archived',
        description: 'Inactive storefronts',
        icon: BsArchive,
    },
]
